import { Product } from "@client/stores";

export const getProcessedItemsData = (products: Product[]) => {
	return products.map((product) => {
		return {
			barcode: product.sku,
			qty_canceled: product.order_details?.qtyCanceled,
			qty_ordered:
				(product.order_details?.quantity ?? 0) -
				(product.order_details?.qtyCanceled ?? 0),
		};
	});
};
